import { render, staticRenderFns } from "./Counter.vue?vue&type=template&id=403c116d&scoped=true&"
import script from "./Counter.vue?vue&type=script&lang=ts&"
export * from "./Counter.vue?vue&type=script&lang=ts&"
import style0 from "./Counter.vue?vue&type=style&index=0&id=403c116d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403c116d",
  null
  
)

export default component.exports